import styled, { css, keyframes } from 'styled-components';
import { StyledHolder } from '../../Avatar/styled';

const selected = keyframes`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;

export const StyledSectionItem = styled.div`
  ${(p) =>
    !p.isPlain &&
    css`
      display: flex;
      grid-gap: ${(p) => p.theme.space[3]};
      align-items: top;
      justify-content: space-between;
    `}

  position: relative;
  padding: ${(p) =>
    (!p.isBlock &&
      !p.isSmall &&
      !p.isPadded &&
      `${p.theme.space[2]} ${p.theme.space[3]}`) ||
    (p.isSmall && `${p.theme.space[1]} ${p.theme.space[2]}`) ||
    (p.isPadded && `${p.theme.space[2]} ${p.theme.space[6]}`)};
  height: ${(p) => p.isBlock && p.theme.space[4]};
  box-shadow: ${(p) => p.theme.shadows.bottom};

  &:first-child {
    box-shadow: ${(p) => p.theme.shadows.y};
  }

  ${(p) =>
    p.isWell &&
    `
    &::before {
      content: '';
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
      opacity: 1;
      position: absolute;
      background-color: ${p.theme.alias.light}
    }
  `}

  ${(p) =>
    p.isSelected &&
    css`
      &::before {
        animation: ${selected} 2000ms ease-out;
        content: '';
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        z-index: -1;
        position: absolute;
        background-color: ${p.theme.alias.primaryBack};
      }
    `}

  ${StyledHolder} {
    background-color: ${(p) => p.isActive && p.theme.alias.bg};
  }
`;
